<template>
  <div id="app">
    <router-view />
    <feedback-dialog ref="feedbackDialog"></feedback-dialog>
  </div>
</template>

<script>
import DevicePixelRatio from './assets/js/devicePixelRatio'
import FeedbackDialog from './components/FeedbackDialog.vue'

export default {
  name: "app",
  components: {
    FeedbackDialog
  },
  data() {
    return {};
  },
  watch: {
    '$route': {
      handler: function () {
        var infoPc = navigator.userAgent;
        //通过正则表达式的test方法判断是否包含“Mobile”字符串
        var isPhone = /mobile/i.test(infoPc);
        let pageWidth = document.documentElement.clientWidth
        if (!isPhone && pageWidth >= 1200) {
          new DevicePixelRatio().init()
        }
      },
      immediate: true
    }
  },
  created() {
    localStorage.setItem('iosUrl', window.location.href)
    document.title = 'Report 钛客网'
    var infoPc = navigator.userAgent;
    //通过正则表达式的test方法判断是否包含"Mobile"字符串
    var isPhone = /mobile/i.test(infoPc);
    let pageWidth = document.documentElement.clientWidth
    if (!isPhone && pageWidth >= 1200) {
      new DevicePixelRatio().init()
    }
  },
  mounted() {
    // 监听意见反馈事件
    this.$bus.$on('openFeedbackDialog', () => {
      this.$refs.feedbackDialog.openDialog();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$bus.$off('openFeedbackDialog');
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
@import "./assets/font/font.css";

* {
  font-family: "Alibaba-PuHuiTi-Regular";
}

/* 意见反馈成功消息样式 */
.feedback-success-message {
  z-index: 9999 !important;
  position: fixed !important;
  top: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  min-width: 300px !important;
  text-align: center !important;
}

/* 确保消息不会被其他元素遮挡 */
.el-message {
  z-index: 9999 !important;
}

@media screen and (max-width: 1200px) {
  body {
    height: 100%;
    margin: 0;
  }
}

@media screen and (min-width: 1200px) {
  body {
    height: 100vh;
    margin: 0;
  }
}

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.avue--detail .el-col {
  margin-bottom: 0;
}
</style>
